import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { CircularProgress } from '@material-ui/core';
import * as auth from "../_redux/authRedux";
import { loginWithGoogle } from "../_redux/authCrud";

function GoogleLogin(props) {
  const history = useHistory();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleGoogleLogin = async () => {
      try {
        console.log('🔵 Starting Google login...');
        
        // Perform Google login (popup and backend sync)
        await loginWithGoogle();
        
        console.log('✅ Google login successful');
        
        // Trigger Redux actions
        props.login();
        props.updateToken();
        
        // Redirect to dashboard
        console.log('🔄 Redirecting to dashboard...');
        history.push('/dashboard');
        
      } catch (err) {
        console.error('❌ Google login failed:', err);
        setError(err.message || 'Google login failed');
        
        // Redirect back to login after 3 seconds
        setTimeout(() => {
          history.push('/auth/login');
        }, 3000);
      }
    };

    handleGoogleLogin();
  }, [history, props]);

  return (
    <div className="text-center" style={{ padding: '50px' }}>
      {!error ? (
        <>
          <h3>Logging in with Google...</h3>
          <CircularProgress style={{ marginTop: '20px' }} />
        </>
      ) : (
        <>
          <h3 style={{ color: 'red' }}>Login Failed</h3>
          <p>{error}</p>
          <p>Redirecting to login page...</p>
        </>
      )}
    </div>
  );
}

export default connect(null, auth.actions)(GoogleLogin);